import { render } from "./tiktokCpn.vue?vue&type=template&id=79f18b06&scoped=true"
const script = {}

import "./tiktokCpn.vue?vue&type=style&index=0&id=79f18b06&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f18b06"]])

export default __exports__